import { useEffect, useRef } from "react"
import { useLocation } from "react-router-dom"
import { useRequest } from "./useRequest"
import { Notification } from "../types/entities/notification"
import { userStore } from "../store/userStore"

export async function fetchUnreadMessagesCount(
    requestData: ReturnType<typeof useRequest>["requestData"],
): Promise<number> {
    const res = await requestData<Notification[]>({ type: "GET", path: "user/message", disableError: true })
    if (res.status === "error" || !Array.isArray(res.data)) return 0
    return res.data.filter(item => !item.read).length
}

/** Обновляет счётчик непрочитанных при навигации и возврате на вкладку. */
export function useUnreadNotifications() {
    const location = useLocation()
    const { requestData } = useRequest()
    const userToken = userStore(state => state.user?.token)
    const setUnreadMessages = userStore(state => state.setUnreadMessages)
    const requestDataRef = useRef(requestData)
    requestDataRef.current = requestData

    const refresh = async () => {
        if (!userToken) {
            setUnreadMessages(0)
            return
        }
        try {
            const count = await fetchUnreadMessagesCount(requestDataRef.current)
            setUnreadMessages(count)
        } catch {
            /* ignore */
        }
    }

    useEffect(() => {
        if (!userToken) {
            setUnreadMessages(0)
            return
        }
        // На странице уведомлений список грузится отдельно и сам обновляет счётчик.
        if (location.pathname === "/profile/notifications") return
        refresh()
    }, [userToken, location.pathname, location.search, location.key])

    useEffect(() => {
        if (!userToken) return

        const onVisibilityChange = () => {
            if (document.visibilityState === "visible") refresh()
        }
        document.addEventListener("visibilitychange", onVisibilityChange)
        return () => document.removeEventListener("visibilitychange", onVisibilityChange)
    }, [userToken])
}
